import { render } from "./platformZh.vue?vue&type=template&id=6a502356&scoped=true"
import script from "./platformZh.vue?vue&type=script&lang=js"
export * from "./platformZh.vue?vue&type=script&lang=js"

import "./platformZh.vue?vue&type=style&index=0&id=6a502356&scoped=true&lang=scss"

import exportComponent from "/Users/adrian/vue/laolife/newlife-web-about/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a502356"]])

export default __exports__